if (!customElements.get('product-gallery')) {
  customElements.define(
    'product-gallery',
    class ProductGallery extends HTMLElement {
      constructor() {
        super();
        this.sliderMain = this.querySelector(`#SliderMain-${this.productID}`);
        this.sliderThumb = this.querySelector(`#SliderThumb-${this.productID}`);
        if (!this.sliderMain && !this.sliderThumb) return;
        this.initSlider();
      }

      get productID() {
        return this.dataset.id;
      }

      initSlider() {
        const mainSliderOptions = {
          slidesPerView: 1,
          slidesPerMove: 1,
          pagination: false,
          navigation: false,
          thumbs: {
            swiper: this.sliderThumb,
          },
        };

        const thumbSettings = {
          slidesPerView: 'auto',
          slidesPerMove: 1,
          pagination: false,
          navigation: false,
          direction: 'vertical',
          spaceBetween: 8,
        };

        const slider = new Swiper(this.sliderMain, mainSliderOptions);
        const thumbSlider = new Swiper(this.sliderThumb, thumbSettings);
      }
    }
  );
}
